export const SEARCH_RESULT_CLASSNAME = 'search-result';
export const SEARCH_RESULT_CONTEXT = 'search-result';

/** Prefix for all comment type search results */
export const COMMENT_MIMETYPE_PREFIX = 'comment-';

/** Share of a result block that must be in the viewport to count it as seen. */
export const RESULT_VISIBLE_THRESHOLD = 0.5;
